import { AvailabilitiesSearchBarComponent } from "./availabilities-search-bar/availabilities-search-bar.component";

export {
  AvailabilitiesSearchBarComponent,
};

export const availabilitiesComponents = [
  AvailabilitiesSearchBarComponent,
]
